import { Link, Navigate } from 'react-router-dom';
import { Spinner } from '@/components/ui/Spinner';
import { useSession } from '@/hooks/useSession';
import { getLoginPath } from '@/lib/loginPath';
import { postLoginHomePath } from '@/lib/mobileAdminPaths';
import { HomePage } from '@/pages/HomePage';
import { AppVersionLabel } from '@/components/AppVersionLabel';

export function PublicLanding() {
  const { ok, loading } = useSession();

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-app-mesh">
        <Spinner label="加载中" />
      </div>
    );
  }

  if (ok) {
    return <Navigate to={postLoginHomePath()} replace />;
  }

  return (
    <div className="min-h-screen bg-app-mesh">
      <header
        className="sticky top-0 z-40 border-b border-slate-200/70 bg-white/85 shadow-sm shadow-slate-900/[0.05] backdrop-blur-xl"
        style={{ paddingTop: 'max(0.5rem, env(safe-area-inset-top))' }}
      >
        <div className="mx-auto flex max-w-7xl flex-wrap items-center justify-between gap-3 px-4 py-3 sm:gap-4 sm:px-6 lg:px-8">
          <div className="flex min-w-0 flex-1 items-center gap-3 sm:flex-none">
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-brand-icon text-lg text-white shadow-md shadow-teal-900/20 ring-1 ring-white/10">
              <i className="fa-solid fa-shrimp" aria-hidden />
            </span>
            <div className="min-w-0">
              <p className="text-[15px] font-semibold tracking-tight text-slate-900">贴图虾</p>
              <p className="truncate text-xs text-slate-500 sm:whitespace-normal">
                登记汇聚 · 公众号贴图与协作
              </p>
            </div>
          </div>
          <Link
            to={getLoginPath()}
            className="inline-flex w-full shrink-0 items-center justify-center rounded-xl bg-gradient-to-b from-teal-500 to-teal-600 px-4 py-2.5 text-sm font-semibold text-white shadow-md shadow-teal-900/25 ring-1 ring-teal-500/25 transition hover:from-teal-400 hover:to-teal-600 sm:w-auto"
          >
            登录后台
          </Link>
        </div>
      </header>
      <main className="mx-auto max-w-7xl px-4 pb-16 pt-8 sm:px-6 sm:pb-20 sm:pt-10 lg:px-8">
        <HomePage />
      </main>
      <footer className="border-t border-slate-200/70 bg-white/60 py-5 text-center backdrop-blur-sm">
        <AppVersionLabel className="text-slate-500" />
      </footer>
    </div>
  );
}
